/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AnswerTo } from '../../models/answer-to';
import { Date } from '../../models/date';

export interface ApiWebCzyIdentyfikatorKorektyWolnyGet$Params {
  dataKorekty: Date;
  identyfikatorTr: string;
  nip: string;
}

export function apiWebCzyIdentyfikatorKorektyWolnyGet(http: HttpClient, rootUrl: string, params: ApiWebCzyIdentyfikatorKorektyWolnyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AnswerTo>> {
  const rb = new RequestBuilder(rootUrl, apiWebCzyIdentyfikatorKorektyWolnyGet.PATH, 'get');
  if (params) {
    rb.query('dataKorekty', params.dataKorekty, {});
    rb.query('identyfikatorTr', params.identyfikatorTr, {});
    rb.query('nip', params.nip, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AnswerTo>;
    })
  );
}

apiWebCzyIdentyfikatorKorektyWolnyGet.PATH = '/api/web/czy/identyfikatorKorektyWolny';
